import { render } from "./RegisterRne.vue?vue&type=template&id=5dcc6e5e&scoped=true"
import script from "./RegisterRne.vue?vue&type=script&lang=js"
export * from "./RegisterRne.vue?vue&type=script&lang=js"

import "./RegisterRne.vue?vue&type=style&index=0&id=5dcc6e5e&scoped=true&lang=css"
import "./RegisterRne.vue?vue&type=style&index=1&id=5dcc6e5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dcc6e5e"]])

export default __exports__